import React from 'react';
import { get } from 'lodash';
import Relatorio from '../../../../components/v2/relatorio/Relatorio';
import { ComponentBase } from '../../../../base';
import caption from '../../../../components/v2/consts';
import { API_URL } from '../../../../consts';


class DistribuicaoNotasCompetenciaTime extends ComponentBase {
  get columns() {
    const { projeto } = this.props;
    const possui_competencia_5 = get(projeto, 'possui_competencia_5')

    const competencias = possui_competencia_5 ? [1, 2, 3, 4, 5] : [1, 2, 3, 4]
    return [
      {
        header: '#',
        accessor: 'row',
        minWidth: 50,
        Cell: row => <div>{row.index + 1}</div>,
        footer: {
          mediaNacional: {
            accessor: '',
            default: '-',
          },
          mediaTime: {
            accessor: '',
            default: '-',
          },
        },
      },
      {
        header: 'Polo',
        withSortIcon: true,
        accessor: 'polo_descricao',
        Cell: d => (<div className="column-left">{d.value}</div>),
        minWidth: 200,
        footer: {
          mediaNacional: {
            accessor: '',
            default: 'Dist. Nacional',
          },
          mediaTime: {
            accessor: '',
            default: 'Dist. Time',
          },
        },
      },
      {
        header: 'Time',
        withSortIcon: true,
        accessor: 'time_descricao',
        Cell: d => (<div className="column-left">{d.value}</div>),
        minWidth: 200,
        footer: {
          mediaNacional: {
            accessor: '',
            default: '-',
          },
          mediaTime: {
            accessor: '',
            default: '-',
          },
        },
      },
      {
        header: 'Avaliadores',
        withSortIcon: true,
        accessor: 'avaliador',
        Cell: d => (<div className="column-left">{d.value}</div>),
        minWidth: 300,
        footer: {
          mediaNacional: {
            accessor: '',
            default: '-',
          },
          mediaTime: {
            accessor: '',
            default: '-',
          },
        },
      },
      {
        header: 'Corrigidas',
        accessor: 'nr_corrigidas',
        defaultValue: 0,
        withSortIcon: true,
        minWidth: 120,
        footer: {
          mediaNacional: {
            accessor: 'nr_corrigidas',
            default: '-',
          },
          mediaTime: {
            accessor: 'nr_corrigidas',
            default: '-',
          },
        },
      },
      {
        header: 'Com Nota Normal',
        withSortIcon: true,
        accessor: 'nr_com_nota_normal',
        defaultValue: 0,
        minWidth: 180,
        footer: {
          mediaNacional: {
            accessor: 'media_com_nota_normal',
            default: '-',
          },
          mediaTime: {
            accessor: 'media_com_nota_normal',
            default: '-',
          },
        },
      },
    ].concat(
      competencias.map((competencia) => {
        const numeral = {
          1: 'I',
          2: 'II',
          3: 'III',
          4: 'IV',
          5: 'V',
        }[competencia];

        let marcacoes;
        if (competencia === 2) {
          marcacoes = [1, 2, 3, 4, 5];
        } else {
          marcacoes = [0, 1, 2, 3, 4, 5];
        }

        return {
          header: `Competência ${numeral} (%)`,
          columns: marcacoes.map(marcacao => ({
            header: marcacao,
            headerClassName: 'table-competencia',
            withSortIcon: true,
            sortMethod: true,
            accessor: `media_competencia${competencia}_${marcacao}`,
            defaultValue: '0,00',
            maxWidth: 70,
            footer: {
              mediaNacional: {
                accessor: `media_competencia${competencia}_${marcacao}`,
                default: '-',
              },
              mediaTime: {
                accessor: `media_competencia${competencia}_${marcacao}`,
                default: '-',
              },
            },
          })),
        };
      }),
    );
  }

  render() {
    const backAction = this.hasPermission('ver_relatorio_distribuicao_notas_competencia_polo') ? {
      path: '/relatorios/v2/distribuicao-notas-competencia-time',
      state: ['polo'],
    } : undefined;

    const exportData = {
      url: `${API_URL}/v2/relatorios/distribuicao-notas-competencia/times/excel`,
      filename: 'distribuicao_notas_competencia_por_time.xlsx',
      hasPermission: this.hasPermission('exportar_relatorio'),
    };

    return (
      <Relatorio
        isPoloInputRequired
        isTimeInputRequired
        title="DISTRIBUIÇÃO DE NOTAS | Avaliadores"
        dataUrl="v2/relatorios/distribuicao-notas-competencia/times"
        mediaNacionalUrl="v2/relatorios/distribuicao-notas-competencia/geral/media"
        mediaTimeUrl="v2/relatorios/distribuicao-notas-competencia/geral/media"
        fetchCorretoresInativos="correcoes/corretores_inativos"
        columns={this.columns}
        backAction={backAction}
        codigo="DISTRIBUICAO_NOTAS_COMPETENCIA"
        caption={caption}
        exportData={exportData}
        codigoMensagem="DISTRIBUICAO_NOTAS_COMPETENCIA_AVALIADORES"
        baseAvaliadores
      />
    );
  }
}

export default DistribuicaoNotasCompetenciaTime;
